<template>
  <v-checkbox
    :label="label"
    :input-value="fieldValue"
    :success-messages="successes"
    :error-messages="errors"
    :disabled="disabled"
    @change="value => fieldValue = value"
    :loading="loading"
  >
  </v-checkbox>
</template>

<script>
export default {
  props: [
    'label', 'fieldName', 'object', 'disabled'
  ],
  computed: {
    fieldValue: {
      get: function() {
        // if this is in the employee skills, return true
        // otherwise return false
        return this.$store.state.employees.detailedEmployee.global_skills.find(skillName => skillName == this.fieldName)
      },
      set: function(newValue) {
        this.loading = true;
        this.$store.dispatch(
          'employees/addRemoveSkill',
          { id: this.object.id, skill: this.fieldName, adding: newValue }
        )
        .then(res => {
          this.errors = []
          this.successes.push("Saved!")
          this.successClear = setInterval(() => {
            this.wipeSuccesses()
          }, 1500);

        })
        .catch(res => {
          this.errors.push("Couldn't be saved")
          // reset the value?
        })
        .finally(res => {
          this.loading = false;
        })
      }
    }
  },

  methods: {
    wipeSuccesses: function() {
      this.successes = []
    }
  },

  data: function() {
    return {
      loading: false,
      fallback: '',
      errors: [],
      successes: [],
    }
  }
}
</script>
